module.exports = __webpack_public_path__ + "static/media/protein_img.59651170.svg";